import React from "react";
import { SFSlideThumbnail } from "../thumbnails";

const SFCarouselSlide = ({
  title,
  description = "",
  image = null,
  stats = [],
  icon = null,
  onClick = null,
  lazyLoad = false,
  badge = null,
  hoverStats = [],
  hasHover = false,
  scaleOnHover = false,
  height = 100,
  indicator = null,

}) => (
  <SFSlideThumbnail
    title={title}
    description={description}
    image={image}
    stats={stats}
    icon={icon}
    onClick={onClick}
    lazyLoad={lazyLoad}
    badge={badge}
    hoverStats={hoverStats}
    hasHover={hasHover}
    scaleOnHover={scaleOnHover}
    height={height}
    indicator={indicator}
  />
);

export default SFCarouselSlide;
